import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import Carousel from 're-carousel';
import IndicatorDots from '../../components/signup-ads-instagram-carousel-indicators/component'
import {BeatLoader} from "react-spinners";
import {langRegister} from "../../services/langRegister";
import {EventEmitter} from "../../services/eventRegister";
import {videoRegister} from "../../services/videoRegister";
import {carouselRegister} from "../../services/carouselRegister";
import {Line} from "rc-progress";
import {cartRegister} from "../../services/cartRegister";

class SignupAdsInstagramCarousel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: [],
            progress: 0,
            custom_slides: []
        };
    };

    componentWillMount(){
        let cart = cartRegister.get();
        let custom_slides = [];
        if(cart.admin_slideshow_images){
            custom_slides = cart.admin_slideshow_images.filter((item) => {
                try{
                    return item.images.small && item.selected;
                }catch (e) {
                    return false
                }
            }).sort((a, b) => (a.number > b.number) ? 1 : -1).map((item) => {
                return item.images.small;
            });
        }
        try {
            this.setState({
                custom_slides: custom_slides
            });
        }catch (e) {}
    }

    componentDidMount() {
        try {
            EventEmitter.on('carousel', (value) => {
                if(value && this.state.custom_slides.length < 1){
                    this.setState({items: value});
                }else if(this.state.custom_slides.length > 0){
                    this.setState({items: this.state.custom_slides});
                }
            });
        }catch (e) {}
        try {
            EventEmitter.on('carousel-error', (value) => {
                this.setState({error: value});
            });
        }catch (e) {}
        try {
            EventEmitter.on('carousel-progress', (value) => {
                this.setState({progress: value});
            });
        }catch (e) {}
        try {
            let data = carouselRegister.get();
            if(data && this.state.custom_slides.length < 1){
                this.setState({items: data});
            }else if(this.state.custom_slides.length > 0){
                this.setState({items: this.state.custom_slides});
            }
        }catch (e) {}
        try {
            let error = carouselRegister.getError();
            this.setState({error: error});
        }catch (e) {}
        try {
            let progress = carouselRegister.getProgress();
            this.setState({progress: progress});
        }catch (e) {}
    }

    _renderText(item) {
        return langRegister.get("signup-ads-facebook-carousel", item);
    }

    render() {
        return (
            <div className={
                cx(Styles.container,
                    {
                        [Styles.containerEmpty]: this.state.items.length < 1 || this.state.error,
                    })
            }>
                {
                    this.state.items.length > 0 && !this.state.error &&
                    <Carousel interval={2000} loop auto widgets={[IndicatorDots]}>
                        {
                            this.state.items.map((item) => {
                                return (
                                    <div style={{backgroundImage: 'url(' + item + ')'}} className={Styles.containerItem}></div>
                                )
                            })
                        }
                    </Carousel>
                }
                {
                    this.state.items.length < 1 && !this.state.error &&
                    <div className={Styles.containerLoader}>
                        <div className={Styles.containerLoaderProgress}>
                            <Line percent={this.state.progress} strokeWidth="3" strokeLinecap={"square"} strokeColor="#41CBC7" />
                        </div>
                        <div className={Styles.containerLoaderText}>
                            {this._renderText("item_1")}
                        </div>
                    </div>
                }
                {
                    this.state.error &&
                    <div className={Styles.containerLoading}>
                        <div className={Styles.containerLoadingInner}>
                            <div className={cx(Styles.containerLoaderText, Styles. containerLoadingTextError)}>
                                {this._renderText("item_2")}
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default SignupAdsInstagramCarousel;


// WEBPACK FOOTER //
// ./src/components/signup-ads-instagram-carousel/component.js